<template>
  <div v-if="remianSeconds > 0" :class="$style.root">
    <slot :day="dayStr" :hour="hourStr" :minute="minuteStr" :second="secondStr">
      <span :class="$style.day">{{ dayStr }}</span
      ><span :class="$style.daySplit">天</span><span :class="$style.time">{{ hourStr }}</span
      ><span :class="$style.timeSplit">:</span><span :class="$style.time">{{ minuteStr }}</span
      ><span :class="$style.timeSplit">:</span><span :class="$style.time">{{ secondStr }}</span>
    </slot>
  </div>
</template>

<script>
import Vue from "vue";

let insCount = 0;
let timer;
const timeState = Vue.observable({
  currentTime: null,
});

const startTicker = () => {
  insCount += 1;
  if (timer !== undefined) return;

  timer = setInterval(() => {
    timeState.currentTime = new Date().getTime();
  }, 1000 / 6);
};

const desotryTicker = () => {
  if (--insCount <= 0) {
    clearTimeout(timer);
  }
};

const padding = str => ("00" + str).slice(-2);

export default {
  name: "Countdown",
  props: {
    time: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    timePassed() {
      if (timeState.currentTime === null || this.startTime === null) return 0;

      return timeState.currentTime - this.startTime;
    },
    dayStr() {
      return this.remianDay;
    },
    hourStr() {
      return padding(this.remianHour % 24);
    },
    minuteStr() {
      return padding(this.remianMinute % 60);
    },
    secondStr() {
      return padding(this.remianSeconds % 60);
    },
    remianDay() {
      return Math.floor(this.remianHour / 24);
    },
    remianHour() {
      return Math.floor(this.remianMinute / 60);
    },
    remianMinute() {
      return Math.floor(this.remianSeconds / 60);
    },
    remianSeconds() {
      return Math.ceil(this.remainTime / 1000);
    },
    remainTime() {
      return Math.max(0, this.time - this.timePassed);
    },
  },
  data() {
    return {
      startTime: null,
      // timeState,
    };
  },
  watch: {
    time: {
      immediate: true,
      handler(value) {
        if (this._tick) {
          this.startTime = new Date().getTime();
          if (this.remianSeconds <= 0) {
            this.unTick();
          }
          return;
        } else if (this.remianSeconds > 0) {
          this.tick();
        }
      },
    },
    remianSeconds(value, old) {
      this.$emit("update:time", this.remainTime);
      if (value <= 0) {
        this.unTick();
      }
    },
  },
  methods: {
    getRemainTime() {
      return this.remainTime;
    },
    tick() {
      this._tick = true;
      this.startTime = new Date().getTime();
      startTicker();
    },
    unTick() {
      if (!this._tick) {
        return;
      }

      this._tick = false;
      desotryTicker();
    },
  },
  beforeDestroy() {
    this.unTick();
  },
};
</script>

<style lang="scss" module>
.root {
  font-size: 12px;
  line-height: 1;
}
</style>
